'use client';

import { TranslatedProjects } from '@/components/shared';
import { QueryWrapper } from '@/components/shared/query-wrapper';
import { CaseStudyGrid } from '@/features/home/components/case-study-grid';
import { homeConfig } from '@/features/home/home.config';
import { useProjects, useLocalePath } from '@/shared/hooks';
import { useT } from 'next-i18next/client';
import Link from 'next/link';
import type { FC } from 'react';

const CaseStudiesGridWithReactQuery: FC = () => {
  const { data: projects, isLoading, error } = useProjects();

  return (
    <QueryWrapper isLoading={isLoading} error={error} data={projects}>
      {(projects) => (
        <TranslatedProjects
          projects={projects}
          renderProjects={(projects) => <CaseStudyGrid projects={projects} />}
        />
      )}
    </QueryWrapper>
  );
};

export const CaseStudiesBlock: FC = () => {
  const { t } = useT(homeConfig.i18nNamespaces);
  const { to } = useLocalePath();

  return (
    <section className="bg-[#0A0A0A] py-24 md:py-[96px]">
      <div className="container">
        <div className="flex justify-between items-end mb-12">
          <div>
            <p className="text-xs font-medium tracking-widest uppercase text-[#F24E1E]">
              {t('home:caseStudies.label')}
            </p>
            <h2 className="mt-4 text-[clamp(36px,4vw,56px)] font-medium tracking-[-0.025em] leading-[1] text-white">
              {t('home:caseStudies.title')}
            </h2>
          </div>
          <Link
            href={to('/projects')}
            className="text-sm text-white/40 hover:text-white transition-colors duration-150 whitespace-nowrap"
          >
            {t('home:caseStudies.viewAll')} →
          </Link>
        </div>
        <CaseStudiesGridWithReactQuery />
      </div>
    </section>
  );
};
